$(document).ready(function () {
    $('header').scrollAnimation({
        elements: {
            'header': {
                '0px': {
                    'height': '130px',
                },
                '1px': {
                    'height': '54px'
                }
            },
            'header #logo': {
                '0px': {
                    'height': '130px'
                },
                '1px': {
                    'height': '54px'
                }
            },
            'body.cms-menu-visible .alert.alert-fixed-top': {
                '0px': {
                    'margin-top': '178px'
                },
                '1px': {
                    'margin-top': '102px'
                }
            },
            'body:not(.cms-menu-visible) .alert.alert-fixed-top': {
                '0px': {
                    'margin-top': '130px'
                },
                '1px': {
                    'margin-top': '54px'
                }
            }
        },
        scrollObject: '#viewport',
        wrapObject: '#site-wrapper'
    });
});
